__turbopack_context__.v({
  "error": "CheckboxButton-module__m7jY_G__error",
  "labelWrapper": "CheckboxButton-module__m7jY_G__labelWrapper",
  "wrapper": "CheckboxButton-module__m7jY_G__wrapper",
});
